import { formatDate } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { SubSink } from 'subsink';
import { AppConfig } from '../../core/config/app.config';
import { AppConfigConstants } from '../../core/config/app.config.constants';
import { AuthenticationConstants, PermissionConstants } from '../constants';
import { ATSClientTypeConstants } from '../constants/ats-client-type.constants';
import { User } from '../models';
import { Applicant } from '../models/Applicant';
import { AuthenticationLocalStorageService } from '../services/authentication-local-storage.service';
import { DocumentService } from '../services/document.service';
import { hasPermission } from '../Utility/user-permission.helper';
import * as routerActions from './../../state/actions/router.actions';
import * as fromAuthentificationActions from './../state/actions/authentication.action';
import * as fromShared from './../state/reducers';
import * as fromAuthentificationSelector from './../state/selectors/authentication.selectors';
@Component({
  selector: 'ats-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit, OnDestroy {

  constructor(private sharedStore: Store<fromShared.State>,
    public authenticationLocalStorageService: AuthenticationLocalStorageService,
    private documentService: DocumentService
  ) { }
  applicant$: Observable<Applicant>;
  user$: Observable<User>;
  permissionConstants = PermissionConstants;
  private subs = new SubSink();
  ngOnInit() {
    this.applicant$ = this.sharedStore.pipe(select(fromAuthentificationSelector.LoggedInApplicant));
    this.user$ = this.sharedStore.pipe(select(fromAuthentificationSelector.LoggedInUser));
  }

  logoutApplicant(): void {
    this.sharedStore.dispatch(fromAuthentificationActions.LogoutApplicant());
    this.sharedStore.dispatch(new routerActions.Go({ path: ['home'] }));
  }

  logoutUser(): void {
    this.sharedStore.dispatch(fromAuthentificationActions.LogoutUser());
    this.sharedStore.dispatch(new routerActions.Go({ path: ['home'] }));
  }

  checkPermission(user: User, permissionIds: number[]): boolean {
    return hasPermission(user, permissionIds);
  }

  getActiveApplicationsByPolygraher(): void {
    this.subs.sink = this.documentService.getActiveApplicationsByPolygrapherReport().subscribe(
      (res) => {
        var fileURL = URL.createObjectURL(res);
        var link = document.createElement('a');
        link.href = fileURL;
        link.download = `Active Applications By Polygrapher(${formatDate(new Date(), 'dd-MM-yyyy', 'en')}).pdf`;
        link.click();
        //The windows.opens the file but with a guid name
        //window.open(fileURL);
        setTimeout(function () {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(fileURL);
        }, 100);
      }
    );
  }

  isForApplicantClient(): boolean {
    return AppConfig.appSetting(AppConfigConstants.ATS_CLIENT_TYPE) === ATSClientTypeConstants.APPLICANT ||
      AppConfig.appSetting(AppConfigConstants.ATS_CLIENT_TYPE) === ATSClientTypeConstants.APPLICANT_AND_USER;
  }

  isForUserClient(): boolean {
    return AppConfig.appSetting(AppConfigConstants.ATS_CLIENT_TYPE) === ATSClientTypeConstants.USER ||
      AppConfig.appSetting(AppConfigConstants.ATS_CLIENT_TYPE) === ATSClientTypeConstants.APPLICANT_AND_USER;
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
